export default class FloatingButton {
    static init() {
        new FloatingButton(document.querySelector('.floating-form'));
    }

    constructor(element) {
        if (!element) {
            return;
        }

        element.addEventListener('click', (e) => {
            const href = element.getAttribute('href');
            if (href.startsWith('#') || href.startsWith('mailto:') || element.getAttribute('target') === '_blank') {
                return;
            }

            element.classList.add('floating-form--is-active');
            document.body.classList.add('body--is-closing--without-preloader-chevrons');
        });

        window.addEventListener('scroll', () => {
            let isScrolledEnough = window.scrollY > window.innerHeight * 0.5;
            element.classList[isScrolledEnough ? 'add' : 'remove']('is-visible');
        });

        window.addEventListener('pageshow', () => {
            document.body.classList.remove('body--is-closing--without-preloader-chevrons');
            element.classList.remove('floating-form--is-active');
        });
    }
}
